export const AgendaProConst = {
    fecha: 'FECHA',
    direccion: 'DIRECCION',
    identificacion: 'IDENTIFICACION',
    nombre: 'NOMBRE',
    correo: 'CORREO',
    telefono: 'TELEFONO'
    

}